import type { AuthSession } from '@kitchen-inventory/shared-types';

import { apiClient } from '@/core/http/api-client.js';

import type { Credentials } from '../domain/credentials.js';

/** Único punto de contacto del feature con el transporte. */
export async function login(credentials: Credentials): Promise<AuthSession> {
  return apiClient.login(credentials);
}

export async function logout(refreshToken: string): Promise<void> {
  await apiClient.logout({ refreshToken });
}

export async function refresh(refreshToken: string): Promise<AuthSession> {
  return apiClient.refreshSession({ refreshToken });
}
